import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import Isvg from 'react-inlinesvg';
import { Theme } from '../../config/theme';

const CHECK_ASSET = require('./check.svg');

export default class CheckButton extends Component {
  constructor(props) {
    super(props);
    this.toggleSelected = this.toggleSelected.bind(this);
  }

  toggleSelected() {
    this.props.onSelect(this.props.name, this.props.id, !this.props.selected);
  }

  render() {
    return (
      <div
        role="button"
        tabIndex={0}
        className={this.props.selected ?
            css(styles.activity_card, styles.activity_card_selected)
          :
            css(styles.activity_card)
        }
        onClick={this.toggleSelected}
      >
        <span className={css(styles.activity_label)}>{this.props.label}</span>
        <Isvg
          cacheGetRequests
          src={CHECK_ASSET}
          className={this.props.selected ?
            css(styles.check, styles.check_visible)
          :
            css(styles.check)
          }
        />
      </div>
    );
  }
}

CheckButton.defaultProps = {
  onSelect: () => {},
};

CheckButton.propTypes = {
  id: PropTypes.oneOf([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  name: PropTypes.string.isRequired,
  onSelect: PropTypes.func,
  label: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
};

const styles = StyleSheet.create({
  activity_card: {
    display: 'flex',
    alignItems: 'center',
    width: 244,
    height: 50,
    padding: 15,
    color: '#828282',
    backgroundColor: '#f4f4f4',
    border: 'solid 1px #e0e0e0',
    borderRadius: 5,
    margin: '6px 4.5px',
    cursor: 'pointer',
    transition: 'all 300ms',
    outline: 'none',
    'user-select': 'none',
    [Theme.mobile_query]: {
      width: '100%',
      margin: '6px 0',
      height: 62,
      flexShrink: 0,
    },
    ':hover': {
      color: '#000e1f',
      backgroundColor: '#fff',
      boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12)',
    },
  },
  activity_card_selected: {
    color: '#000e1f',
    backgroundColor: '#fff',
    borderColor: Theme.primary,
    boxShadow: `0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 0 1px ${Theme.primary} inset`,

    ':hover': {
      boxShadow: `0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 0 1px ${Theme.primary} inset`,
    },
  },
  activity_label: {
    flexGrow: 1,
    marginLeft: 10,
    fontFamily: Theme.font_family_primary,
    fontSize: 14,
  },
  check: {
    display: 'block',
    marginRight: 5,
    opacity: 0,
    transition: 'opacity 300ms',
  },
  check_visible: {
    opacity: 1,
  },
});



// WEBPACK FOOTER //
// ./src/components/CheckButton/index.js